/* mega-menu.js — two-tier category flyout.

   Rail is a real WAI-ARIA vertical tablist: Up/Down (and Home/End) move between
   groups with roving tabindex, Tab moves out of the rail into the visible pane.
   Panes are pointer-activated on hover for speed, but hover NEVER opens the
   panel itself — opening is click/Enter only, so the menu can't ambush someone
   whose pointer crosses the header.

   Degrades safely: without JS the panel stays closed and every category is
   still reachable via the mobile drawer and /collections. */
(function () {
  'use strict';

  var OPEN_CLASS = 'is-open';

  function setupMega(panel) {
    var toggle = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (!toggle) return;

    var tabs = Array.prototype.slice.call(panel.querySelectorAll('[role="tab"]'));
    var panes = Array.prototype.slice.call(panel.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function selectTab(index, moveFocus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        tab.classList.toggle('is-selected', on);
        panes[i].classList.toggle('is-shown', on);
        if (on) panes[i].removeAttribute('hidden');
        else panes[i].setAttribute('hidden', '');
      });
      if (moveFocus) tabs[index].focus();
    }

    function isOpen() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    function open() {
      if (isOpen()) return;
      closeAll(panel);
      toggle.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
      /* next frame so the transition has a start state to animate from */
      requestAnimationFrame(function () { panel.classList.add(OPEN_CLASS); });
      document.addEventListener('keydown', onDocKey, true);
      document.addEventListener('pointerdown', onDocPointer, true);
    }

    function close(returnFocus) {
      if (!isOpen()) return;
      toggle.setAttribute('aria-expanded', 'false');
      panel.classList.remove(OPEN_CLASS);
      panel.setAttribute('hidden', '');
      document.removeEventListener('keydown', onDocKey, true);
      document.removeEventListener('pointerdown', onDocPointer, true);
      if (returnFocus) toggle.focus();
    }

    function onDocKey(e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(true); }
    }

    function onDocPointer(e) {
      if (!panel.contains(e.target) && !toggle.contains(e.target)) close(false);
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      isOpen() ? close(false) : open();
    });

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function (e) { e.preventDefault(); selectTab(i, false); });
      /* Pointer reveal is a convenience only — the panel is already open here. */
      tab.addEventListener('mouseenter', function () { selectTab(i, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        selectTab(next, true);
      });
    });

    /* Leaving the whole header closes it — matches how shoppers expect
       megamenus to behave without needing a click. */
    var host = panel.closest('.site-header') || panel.parentElement;
    if (host) {
      host.addEventListener('mouseleave', function () { if (isOpen()) close(false); });
    }

    panel._megaClose = function () { close(false); };
  }

  function closeAll(except) {
    document.querySelectorAll('[data-mega]').forEach(function (p) {
      if (p !== except && p._megaClose) p._megaClose();
    });
  }

  function init() {
    document.querySelectorAll('[data-mega]').forEach(setupMega);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', init);
})();
